import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_CTN_LIST, SET_CURRENT_CTN, SET_HIDDEN_FIELDS, SET_LOGIN_MODEL, SET_MOBILE_ID_DATA } from "../actions/actionTypes";
export var login = function login() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    currentCtn: null,
    ctnList: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === SET_CURRENT_CTN) {
    return _objectSpread(_objectSpread({}, state), {}, {
      currentCtn: action.payload
    });
  }
  if (action.type === SET_CTN_LIST) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ctnList: action.payload
    });
  }
  if (action.type === SET_LOGIN_MODEL) {
    var prevLoginModel = {};
    if (state.loginModel) {
      prevLoginModel = _objectSpread({}, state.loginModel);
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      loginModel: _objectSpread(_objectSpread({}, prevLoginModel), action.payload)
    });
  }
  if (action.type === SET_MOBILE_ID_DATA) {
    var prevMobileIdData = {};
    if (state.loginModel) {
      prevMobileIdData = _objectSpread({}, state.mobileIdData);
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      mobileIdData: _objectSpread(_objectSpread({}, prevMobileIdData), action.payload)
    });
  }
  if (action.type === SET_HIDDEN_FIELDS) {
    return _objectSpread(_objectSpread({}, state), {}, {
      hiddenFields: action.payload
    });
  }
  return state;
};